module.exports = __webpack_public_path__ + "static/privacy-bb65efb900c30eaa33b2c722f7fd3e3d.svg";